// features/auth/authSlice.js
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import * as authAPI from "../api/auth";

// Async thunks

// Авторизация
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({email, password}, {rejectWithValue}) => {
    try {
      const res = await authAPI.login({email, password});
      return res.data; // обычно возвращает профиль или success
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Логаут
export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, {rejectWithValue}) => {
    try {
      await authAPI.logout();
      return {};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Получить профиль
export const fetchProfile = createAsyncThunk(
  "auth/fetchProfile",
  async (_, {rejectWithValue}) => {
    try {
      const res = await authAPI.getProfile();
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  user: null,
  status: "loading", // idle | loading | succeeded | failed
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuthState(state) {
      state.user = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // login
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload.user ?? action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Login failed";
      });

    // logout
    builder
      .addCase(logoutUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.status = "idle";
        state.user = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Logout failed";
      });

    // fetch profile
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Fetch profile failed";
      });
  },
});

export const {resetAuthState} = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;
export const selectIsAuthenticated = (state) => Boolean(state.auth.user);
export const selectIsCheckingAuth = (state) =>
  state.auth.status === "loading";